<template>
	<nio-sheet
		v-model="visible"
		:closeable="true"
		title="全部配置信息"
		:safeAreaInsetBottom="true"
		:lockScroll="true"
	>
		<div class="sheet">
			<div class="section-car-card">
				<nio-image
					class="head-photo"
					v-if="car.basic.commodity_head_photo"
					:loader-height="'162px'"
					:src="cdn(car.basic.commodity_head_photo, '/thumbnail/!300x300r', true)"
				/>
				<nio-icon
					v-if="modelIconMap[car.basic.model]"
					:name="modelIconMap[car.basic.model]"
					:size="28"
					class="logo-certified"
				/>
				<p class="car-name">{{ car.basic.commodity_name }}</p>
			</div>
			<basic-info :car="car" />
			<!-- <key-points v-if="!configSnapshot" :car="car" /> -->
		</div>
	</nio-sheet>
</template>

<script>
import KeyPoints from '@/views1/DetailPage/KeyPoints'
import BasicInfo from '@/views1/DetailPage/BasicInfo'
import { cdn } from '@/util/imgCdn'

export const modelIconMap = {
	EC6: 'icon_nio_ec6',
	EC7: 'icon_nio_ec7',
	EL7: 'icon_nio_el7',
	EP9: 'icon_nio_ep9',
	ES6: 'icon_nio_es6',
	ES7: 'icon_nio_es7',
	ES8: 'icon_nio_es8',
	ET5: 'icon_nio_et5',
	ET7: 'icon_nio_et7'
}

export default {
	name: 'Configuration',
	components: { KeyPoints, BasicInfo },
	props: ['car', 'configSnapshot', 'showConfigSheet'],
	data() {
		return {
			visible: false,
			modelIconMap
		}
	},
	methods: {
		cdn,
		open() {
			this.visible = true
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.sheet {
	overflow: auto;
	padding-bottom: 80px;
	max-height: 600px;
	&::-webkit-scrollbar {
		display: none;
	}
}
.section-car-card {
	background: #f7f7f8;
	width: 100%;
	height: 176px;
	position: relative;
	overflow: hidden;

	.head-photo {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 250px;
	}

	.logo-certified {
		position: absolute;
		height: 16px;
		top: 20px;
		left: 20px;
	}

	.car-name {
		position: absolute;
		top: 50px;
		left: 20px;
		font-size: 12px;
		color: #040b29;
		max-width: 130px;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
